/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetEmbedOptions, GetEmbedResponses } from '../../models/GetEmbed'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get an embed.
 * @summary Download Document
 * {@link /embed/:embed_id}
 */
export function getEmbed<ThrowOnError extends boolean = true>(options: Options<GetEmbedOptions, ThrowOnError>): Promise<UnwrappedResult<GetEmbedResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/embed/{embed_id}', ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetEmbedResponses, ThrowOnError>>
}
